// Cadastro de Funcionário (issue #7). Sem folha de pagamento (ADR / CONTEXT).

import { newId, type Id } from "./ids.ts";
import { isDataISO, type DataISO } from "./datas.ts";
import type { Funcionario, Snapshot } from "./snapshot.ts";

export type { Funcionario };

export interface DadosFuncionario {
  nome: string;
  funcao: string;
  contato: string;
  admissao: string;
}

export class ErroFuncionario extends Error {}

function validar(dados: DadosFuncionario): {
  nome: string;
  funcao: string;
  contato: string;
  admissao: DataISO | null;
} {
  const nome = dados.nome.trim();
  if (nome === "") throw new ErroFuncionario("Informe o nome do funcionário.");
  const admissao = dados.admissao.trim();
  if (admissao !== "" && !isDataISO(admissao)) {
    throw new ErroFuncionario("Data de admissão inválida.");
  }
  return {
    nome,
    funcao: dados.funcao.trim(),
    contato: dados.contato.trim(),
    admissao: admissao === "" ? null : admissao,
  };
}

export function criarFuncionario(
  snapshot: Snapshot,
  dados: DadosFuncionario,
  /** Id gerado no cliente (ADR-0003). Omitido = o domínio gera. */
  id: Id = newId(),
): Snapshot {
  const f: Funcionario = { id, ...validar(dados), ativo: true };
  return { ...snapshot, funcionarios: [...snapshot.funcionarios, f] };
}

export function editarFuncionario(
  snapshot: Snapshot,
  id: Id,
  dados: DadosFuncionario,
): Snapshot {
  if (!snapshot.funcionarios.some((f) => f.id === id)) {
    throw new ErroFuncionario("Funcionário não encontrado.");
  }
  const campos = validar(dados);
  return {
    ...snapshot,
    funcionarios: snapshot.funcionarios.map((f) =>
      f.id === id ? { ...f, ...campos } : f,
    ),
  };
}

export function definirAtivoFuncionario(
  snapshot: Snapshot,
  id: Id,
  ativo: boolean,
): Snapshot {
  if (!snapshot.funcionarios.some((f) => f.id === id)) {
    throw new ErroFuncionario("Funcionário não encontrado.");
  }
  return {
    ...snapshot,
    funcionarios: snapshot.funcionarios.map((f) =>
      f.id === id ? { ...f, ativo } : f,
    ),
  };
}
